import { el } from 'redom';

import application from 'application';

import externalEventCodes from 'event-system/codes/external';

import EventDateTimeView from './event-date-time-view';

class EventPeriodDisplay {

  constructor(event) {

    this.event = event;

    this.eventStartDateTimeView = new EventDateTimeView(event.startTime, event.formattedStartDate, event.formattedStartTime);
    this.eventEndDateTimeView = new EventDateTimeView(event.endTime, event.formattedEndDate, event.formattedEndTime);

    this.placeholderViewEl = el('.placeholder');

    this.el = el('.event-date-time-container-row', [this.eventStartDateTimeView, this.placeholderViewEl, this.eventEndDateTimeView]);

    this.initialize();

  }

  onunmount() {

    application.eventSystem.internal.offAllOn(this);

  }

  registerEventHandlers() {

    const postId = this.event.postId;

    application.eventSystem.internal.eventFor(this, `${postId}:${externalEventCodes.STARTUP_EVENT_UPDATED}`, this.handleStartupEventStartedEvent.bind(this));

  }

  initialize() {

    this.registerEventHandlers();

  }

  update(event) {

    this.event = event;

    this.eventStartDateTimeView.update(event.startTime, event.formattedStartDate, event.formattedStartTime);
    this.eventEndDateTimeView.update(event.endTime, event.formattedEndDate, event.formattedEndTime);

  }

  handleStartupEventStartedEvent(data) {

    this.update(data.event);

  }

}

export default EventPeriodDisplay;